import * as API from "middleware/api";

export const listCedip = (
    creationDate,
    creationDateFrom,
    creationDateTo,
    dueDate,
    dueDateFrom,
    dueDateTo,
    idCedip,
    option,
    orderColumName,
    orderDirection,
    pageNumber,
    status,
) =>
    API.executeWithAccessToken("/cedip.list", {
        creationDate,
        creationDateFrom,
        creationDateTo,
        dueDate,
        dueDateFrom,
        dueDateTo,
        idCedip,
        option,
        orderColumName,
        orderDirection,
        pageNumber,
        status,
    });

export const readCedip = (idCedip, fraction) => API.executeWithAccessToken("/cedip.detail", { idCedip, fraction });

export const downloadList = (
    creationDate,
    creationDateFrom,
    creationDateTo,
    dueDate,
    dueDateFrom,
    dueDateTo,
    idCedip,
    option,
    orderColumName,
    orderDirection,
    pageNumber,
    status,
) =>
    API.executeWithAccessToken("/download.cedip.list", {
        creationDate,
        creationDateFrom,
        creationDateTo,
        dueDate,
        dueDateFrom,
        dueDateTo,
        idCedip,
        option,
        orderColumName,
        orderDirection,
        pageNumber,
        status,
    });

export const downloadDetail = (idCedip, fraction, format) =>
    API.executeWithAccessToken("/cedip.downloadInformation", { idCedip, fraction, format });

export const rejectCedip = (idCedip, fraction, cedip) =>
    API.executeWithAccessToken("/cedip.reject", { idCedip, fraction, cedip });

export const acceptCedip = (idCedip, fraction, cbu, accreditationType) =>
    API.executeWithAccessToken("/cedip.accept", { idCedip, fraction, cbu, accreditationType });
